// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__2JwMG","actionsCol":"EnrolledClinics_actionsCol__UJLhD"};